export var ReferralType;
(function (ReferralType) {
    ReferralType["default"] = "default";
})(ReferralType || (ReferralType = {}));
